// extracted by mini-css-extract-plugin
module.exports = {"boxShadow":"0 .809rem 1.618rem rgba(0,0,0,.15)","spacer":"1.618rem","transition":"all .2s ease-in-out"};